import type { JSX } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { StripeCustomerSessionType } from "@/common/enums/enums";
import { Button } from "@/components/ui/button";
import { ParagraphSkeleton } from "@/components/ui/skeleton/ParagraphSkeleton";
import { useStripeGetSession } from "@/hooks/stripe/useStripeGetSession";
import ManageSubscription from "./components/ManageSubscription";
import { SetupSubscription } from "./components/SetupSubscription";

export default function SubscriptionSettings(): JSX.Element {
  const { t } = useTranslation();
  const {
    result: stripeSession,
    fetch: getSession,
    error,
  } = useStripeGetSession();

  useEffect(() => {
    void getSession();
  }, [getSession]);

  if (error)
    return (
      <div role="alert" className="space-y-3">
        <p>{error}</p>
        <Button onClick={() => void getSession()}>
          {t("settings.subscription.retryBilling")}
        </Button>
      </div>
    );

  if (stripeSession?.type == StripeCustomerSessionType.CUSTOMER_SESSION) {
    return <SetupSubscription stripeSession={stripeSession} />;
  }

  if (stripeSession?.type == StripeCustomerSessionType.BILLING_SESSION) {
    return <ManageSubscription stripeSession={stripeSession} />;
  }

  return <ParagraphSkeleton lines={4} />;
}
